/* DON'T EDIT THIS FILE. This is generated by 'scripts/update-pseudos.js' */
module.exports = {
  pseudoElements: [
    'after',
    'backdrop',
    'before',
    'cue',
    'cue-region',
    'first-letter',
    'first-line',
    'file-selector-button',
    'grammar-error',
    'marker',
    'placeholder',
    'selection',
    'spelling-error',
    'target-text',
  ],

  pseudoClasses: [
    'active',
    'any-link',
    'autofill',
    'blank',
    'checked',
    'current',
    'default',
    'defined',
    'disabled',
    'empty',
    'enabled',
    'first',
    'first-child',
    'first-of-type',
    'fullscreen',
    'future',
    'focus',
    'focus-visible',
    'focus-within',
    'host',
    'hover',
    'indeterminate',
    'in-range',
    'invalid',
    'last-child',
    'last-of-type',
    'left',
    'link',
    'local-link',
    'only-child',
    'only-of-type',
    'optional',
    'out-of-range',
    'past',
    'picture-in-picture',
    'placeholder-shown',
    'paused',
    'playing',
    'read-only',
    'read-write',
    'required',
    'right',
    'root',
    'scope',
    'target',
    'target-within',
    'user-invalid',
    'valid',
    'visited',
  ],
}
